import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import PropTypes from 'prop-types';
import { Quill } from 'react-quill';
import { richTextToolbar } from "../../../../enums";
import CustomColorPicker, { colorProps } from "./custom-color-picker"; //registering custom supported font sizes

var fontSizeArr = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '36px', '48px', '64px', '96px'];
var Size = Quill["import"]('attributors/style/size');
Size.whitelist = fontSizeArr;
Quill.register(Size, true); // Custom Undo button icon component for Quill editor. While it's currently commented out, leaving them here as example of adding custom buttons
// const CustomUndo = () => (
//   <svg viewBox="0 0 18 18">
//     <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
//     <path className="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9" />
//   </svg>
// );
// // Redo button icon component for Quill editor
// const CustomRedo = () => (
//   <svg viewBox="0 0 18 18">
//     <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
//     <path className="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5" />
//   </svg>
// );

/**
 * Custom toolbar for the quill editor
 */

var QuillToolbar = function QuillToolbar(_ref) {
  var toolbarId = _ref.toolbarId,
      selectionColorStyles = _ref.selectionColorStyles,
      toolbarOptionsObj = _ref.toolbarOptionsObj,
      onChangeColor = _ref.onChangeColor,
      onColorPickerVisibilityChange = _ref.onColorPickerVisibilityChange;
  return /*#__PURE__*/React.createElement("div", {
    id: toolbarId
  }, toolbarOptionsObj[richTextToolbar.HEADER] || toolbarOptionsObj[richTextToolbar.SIZE] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, toolbarOptionsObj[richTextToolbar.HEADER] ? /*#__PURE__*/React.createElement("select", {
    className: "ql-header",
    defaultValue: "4"
  }, /*#__PURE__*/React.createElement("option", {
    value: "1"
  }, "Heading 1"), /*#__PURE__*/React.createElement("option", {
    value: "2"
  }, "Heading 2"), /*#__PURE__*/React.createElement("option", {
    value: "3"
  }, "Heading 3"), /*#__PURE__*/React.createElement("option", {
    value: "4"
  }, "Normal")) : null, toolbarOptionsObj[richTextToolbar.SIZE] ? /*#__PURE__*/React.createElement("select", {
    className: "ql-size",
    defaultValue: "14px"
  }, _mapInstanceProperty(fontSizeArr).call(fontSizeArr, function (fontSize, i) {
    return /*#__PURE__*/React.createElement("option", {
      key: i,
      value: fontSize
    }, fontSize);
  }, this)) : null) : null, toolbarOptionsObj[richTextToolbar.BOLD] || toolbarOptionsObj[richTextToolbar.ITALIC] || toolbarOptionsObj[richTextToolbar.UNDERLINE] || toolbarOptionsObj[richTextToolbar.STRIKE] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, toolbarOptionsObj[richTextToolbar.BOLD] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-bold"
  }) : null, toolbarOptionsObj[richTextToolbar.ITALIC] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-italic"
  }) : null, toolbarOptionsObj[richTextToolbar.UNDERLINE] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-underline"
  }) : null, toolbarOptionsObj[richTextToolbar.STRIKE] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-strike"
  }) : null) : null, toolbarOptionsObj[richTextToolbar.COLOR] || toolbarOptionsObj[richTextToolbar.BACKGROUND_COLOR] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, toolbarOptionsObj[richTextToolbar.COLOR] ? /*#__PURE__*/React.createElement(CustomColorPicker, {
    colorProp: colorProps.COLOR,
    selectionColorStyles: selectionColorStyles,
    onChange: onChangeColor,
    onColorPickerVisibilityChange: onColorPickerVisibilityChange
  }) : null, toolbarOptionsObj[richTextToolbar.BACKGROUND_COLOR] ? /*#__PURE__*/React.createElement(CustomColorPicker, {
    colorProp: colorProps.BACKGROUND,
    selectionColorStyles: selectionColorStyles,
    onChange: onChangeColor,
    onColorPickerVisibilityChange: onColorPickerVisibilityChange
  }) : null) : null, toolbarOptionsObj[richTextToolbar.ORDERED_LIST] || toolbarOptionsObj[richTextToolbar.BULLET_LIST] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, toolbarOptionsObj[richTextToolbar.ORDERED_LIST] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-list",
    value: "ordered"
  }) : null, toolbarOptionsObj[richTextToolbar.BULLET_LIST] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-list",
    value: "bullet"
  }) : null) : null, toolbarOptionsObj[richTextToolbar.SUPER_SCRIPT] || toolbarOptionsObj[richTextToolbar.SUB_SCRIPT] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, toolbarOptionsObj[richTextToolbar.SUPER_SCRIPT] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-script",
    value: "super"
  }) : null, toolbarOptionsObj[richTextToolbar.SUB_SCRIPT] ? /*#__PURE__*/React.createElement("button", {
    className: "ql-script",
    value: "sub"
  }) : null) : null, toolbarOptionsObj[richTextToolbar.ALIGN] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/React.createElement("select", {
    className: "ql-align"
  })) : null, toolbarOptionsObj[richTextToolbar.LINK] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/React.createElement("button", {
    className: "ql-link"
  })) : null, toolbarOptionsObj[richTextToolbar.CLEAN] ? /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/React.createElement("button", {
    className: "ql-clean"
  })) : null);
};

QuillToolbar.propTypes = {
  toolbarId: PropTypes.string.isRequired,
  selectionColorStyles: PropTypes.shape({
    color: PropTypes.string,
    background: PropTypes.string
  }).isRequired,
  toolbarOptionsObj: PropTypes.object.isRequired,
  onChangeColor: PropTypes.func.isRequired,
  onColorPickerVisibilityChange: PropTypes.func.isRequired
};
export default QuillToolbar;
//# sourceMappingURL=quill-toolbar.js.map